import { create } from 'zustand'

const useSectionStore =create((set) => ({
    currentSection: '',
    setSection: (section) => set({currentSection : section})
  }));

export default useSectionStore